'use strict';
angular.module('cimerFrontEndApp')
    .controller('GrantSearchCtrl', ['$scope', '$http', '$location', 'Session', 'ApiUrl', function ($scope, $http, $location, Session, ApiUrl) {

        var sessionObject = Session.getSessionObject();
        if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
            $location.url('/');
            return;
        }

        $scope.sort = {
            column: 'GrantName',
            descending: false
        }; 

        $http.get(ApiUrl.url('/Project/') + 'GetProjectsWhereUserIsAdmin')
            .then(function (response) {
                $scope.projects = response.data;
            });

        $scope.getDivisions = function (project) {
            $http.get(ApiUrl.url('/Division/') + 'Divisions/' + project.ProjectId)
                .then(function (response) {
                    $scope.divisions = response.data;
                });
        };

        $scope.selectProject = function () {
            $scope.getGrants($scope.Project, $scope.Division);
            $scope.getDivisions($scope.Project);
        };

        $scope.selectDivision = function () {
            $scope.getGrants($scope.Project, $scope.Division);
        };

        $scope.getGrants = function (project, division) {
            var divisionID = null;
            if (division) {
                divisionID = division.DivisionID;
            }
            $http.get(ApiUrl.url('/Grant/') + 'GetGrantsForGrantSearch/' + project.ProjectId + '/' + divisionID)
                .then(function (response) {
                    $scope.grants = response.data;                
                });
        };
 
        $scope.changeSorting = function(column) {
            var sort = $scope.sort;
 
            if (sort.column == column) {
                sort.descending = !sort.descending;
            } 
            else {
                sort.column = column;
                sort.descending = false;
            }
        };

    }]);
